import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractLayout, CommunicationService } from '@n7-frontend/boilerplate';
import { HomeLayoutConfig as config } from './home-layout.config';
import { Router, ActivatedRoute } from '@angular/router';
import { ChartService } from 'src/app/services/chart.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'dc-home-layout',
  templateUrl: './home-layout.html'
})
export class HomeLayoutComponent extends AbstractLayout implements OnInit, OnDestroy {

  public navigation = 'home';
  public loading = true;
  public hasData = false;

  public titleplaceholder = {
    blocks: [
      { classes: 'dc-title-loading' },
      // { classes: 'thumb-placeholder' },
      { classes: 'dc-text-loading' },
    ]
  };
  public navplaceholder = {
    blocks: [
      { classes: '' },
      { classes: '' },
      { classes: '' },
      { classes: '' },
      { classes: '' },
      { classes: '' },
    ]
  };
  public pageplaceholder = {
    blocks: [
      { classes: 'title-loading' },
      { classes: 'text-loading' },
      { classes: 'page-loading' },
      { classes: 'page-loading' },
      { classes: 'page-loading' },
      { classes: 'page-loading' },
      { classes: 'page-loading' },
      { classes: 'page-loading' },
      { classes: 'page-loading' },
      { classes: 'page-loading' }
    ]
  };

  constructor(
    private communication: CommunicationService,
    private activatedRouter: ActivatedRoute,
    private router: Router,
    private chartService: ChartService
  ) {
    super(config);
  }

  protected initPayload() {
    return {
      communication: this.communication,
      router: this.activatedRouter,
      navRouter: this.router,
    };
  }

  ngOnInit() {
    this.onInit();

    this.lb.widgets['dc-home'].ds.out$.subscribe(data => {this.hasData = !!data;});

    this.activatedRouter.paramMap.subscribe(navParams => {
      const nav = navParams.get('nav');
      const cId = navParams.get('id');
      this.navigate(nav);
    });

  }

  ngOnDestroy() {
    this.onDestroy();
  }

  navigate(payload) {
    let tab = 'home';
    switch (payload) {
      case 'home':
        tab = 'home';
        break;
      case 'print':
        tab = 'print';
        break;
    }
    this.navigation = tab;
    this.loading = false;
  }

  readyPrint() {
    return this.chartService.isReadyForPrint();
  }

}
